var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#BCBDC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0031 5.59961C18.9137 5.59961 21.2722 7.95883 21.2722 10.868C21.2722 13.7778 18.9137 16.1363 16.0031 16.1363C13.094 16.1363 10.7354 13.7778 10.7354 10.868C10.7354 7.95883 13.094 5.59961 16.0031 5.59961ZM15.9996 28.5278C13.0968 28.5278 10.4381 27.4707 8.38742 25.7209C7.88786 25.2948 7.59961 24.67 7.59961 24.0144C7.59961 21.064 9.98752 18.7027 12.9386 18.7027H19.069C22.0208 18.7027 24.3996 21.064 24.3996 24.0144C24.3996 24.6707 24.1128 25.2941 23.6125 25.7202C21.5625 27.4707 18.9032 28.5278 15.9996 28.5278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.a2ff10dca132598a200226e0a6174274.svg";
export { ForwardRef as ReactComponent };